// extracted by mini-css-extract-plugin
module.exports = {"active-certifications":"active-certifications_active-certifications__2HACa"};